<template>
  <div v-if="filteredCategories.length > 0">
    <button
        class="navbar-toggler pb-md-2 pb-4 pt-2 toggle-sl-button d-block d-sm-block d-lg-none ml-md-0 ml-2"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        ref="navbarToggler"
    >
    </button>


    <nav class="navbar navbar-expand-lg navbar-light pl-md-0 pl-4 pt-0 sl-navbar justify-content-lg-start">
      <div class="w-100">

        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="nav nav-tabs d-block border-0 w-100">
            <li v-for="category in filteredCategories" :key="category.id">
              <div class="row mx-0 justify-content-center justify-content-md-start mb-3">
                <div class="categories-options pl-2"
                     :class="category.isSelected ? 'solution-sidenav-link' : null"
                     @click="updatePlatformCategory(category)">
                  {{category.name}}
                  {{`(${category.count})`}}
                </div>
              </div>

            </li>
          </ul>

        </div>
      </div>
    </nav>

  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
import {mapGetters} from "vuex";

export default {
  name: "AllInvoicesCategories",
  data(){
    return{
      INVOICES_CATEGORIES: [
        {
          name: "All",
          tab: CONSTANTS.INVOICES_TAB_ROUTES.ALL_INVOICES,
          id: 1,
          isSelected : false,
          count : 0
        },
        {
          name: "Recently submitted invoices",
          tab: CONSTANTS.INVOICES_TAB_ROUTES.SUBMITTED_INVOICES,
          id: 2,
          isSelected : false,
          count : 0
        },
        {
          name: "Invoices",
          tab: CONSTANTS.INVOICES_TAB_ROUTES.INVOICES,
          id : 3,
          isSelected : false,
          count : 0
        },
        {
          name: "Draft invoices",
          tab: CONSTANTS.INVOICES_TAB_ROUTES.DRAFTS,
          id: 4,
          isSelected : false,
          count: 0
        },
      ]
    }
  },
  computed:{
    ...mapGetters(['formattedInvoices','invoiceDraftRecords','invoiceSubmissionStatusRecords','invoiceCategoryAccessMethods','viewingAPUserDataFor']),
    countTotalInvoiceTabRecords(){
      return (this.formattedInvoices ? this.formattedInvoices.length : 0) + (this.getFormattedCountFor(this.invoiceDraftRecords)) + (this.invoiceSubmissionStatusRecords ? this.invoiceSubmissionStatusRecords.length : 0);
    },
    filteredCategories(){
      let filteredCategories = []

      //This check ensures we get (ALL) as an invoice category always if any of the invoice records(drafts, tracker , invoices) are fetched via API.
      if ((this.$route.fullPath.includes("invoices") || this.$route.fullPath.includes("recently-submitted-invoices") || this.$route.fullPath.includes("draft-invoices")) && this.countTotalInvoiceTabRecords > 0){
        filteredCategories.push({...this.INVOICES_CATEGORIES.find(category => category.id === 1),count: this.countTotalInvoiceTabRecords,isSelected : true})

        this.configureFilteredCategories(filteredCategories)
      }
      return filteredCategories
    }
  },
  methods: {
    getFormattedCountFor(invoiceRecords){
      return this.viewingAPUserDataFor ? 0 : invoiceRecords && invoiceRecords.length > 0 ? invoiceRecords.length : 0
    },
    updatePlatformCategory(category) {
      /* eslint-disable no-console */
      this.$router.replace({name: 'InvoiceCategory', params: { invoiceCategory: category.tab} })
          .catch((ex) => {
            if (ex.name !== 'NavigationDuplicated') {
              console.error(ex)
            }
          });
      this.$emit("onInvoiceCategorySelected", category)

      //The below conditions checks for conditions when any of the category is clicked.
      if((this.invoiceCategoryAccessMethods.clicked === true && category !== undefined)){
        let subEvent = `${Object.keys(CONSTANTS.INVOICES_TAB_ROUTES).find(routes => routes === category.tab)}`
        this.$hhMixpanel.trackEvent('Supplier Central - Clicked on invoice category:', {subEvent : subEvent});
      }
    },
    configureFilteredCategories(filteredCategories){
      //This method is responsible for configuring the items of the left navigation menu depending upon the data from the API and helps toggling the nav item into selected when clicked.

      if (this.invoiceSubmissionStatusRecords && this.invoiceSubmissionStatusRecords.length > 0){
          filteredCategories.push({...this.INVOICES_CATEGORIES.find(category => category.id === 2) ,count :this.invoiceSubmissionStatusRecords.length , isSelected: false })
      }
      if (this.formattedInvoices && this.formattedInvoices.length > 0){
        filteredCategories.push({...this.INVOICES_CATEGORIES.find(category => category.id === 3) ,count :this.formattedInvoices.length , isSelected: false })
      }
      if (this.invoiceDraftRecords && this.invoiceDraftRecords.length > 0 && !this.viewingAPUserDataFor ){
        filteredCategories.push({...this.INVOICES_CATEGORIES.find(category => category.id === 4) ,count :this.invoiceDraftRecords.length , isSelected: false })
      }

      if (Object.values(CONSTANTS.INVOICES_TAB_ROUTES).includes(this.$route.params.invoiceCategory)) {
        let toggledCategory = filteredCategories.find(category => category.tab === this.$route.params.invoiceCategory)
        filteredCategories.forEach(category => {
          category === toggledCategory ? category.isSelected = true : category.isSelected = false
        })
      }
    }
  },
}
</script>

<style scoped>
.categories-options {
  cursor: pointer;
  font-weight: 700;
}

hr {
  margin-top: 0.85rem;
  margin-bottom: 0.85rem;
}
</style>